import { ConfirmDialogComponent } from './shared/ui/confirm-dialog/confirm-dialog.component';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './shared/ui/toast-container/toast-container.component';
import { OrderPreviewModalComponent } from './shared/ui/order-preview-modal/order-preview-modal.component';
import { OrderPreviewService } from './core/services/order-preview.service';
import { BrandingService } from './core/services/branding.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastContainerComponent, OrderPreviewModalComponent, ConfirmDialogComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  /** Page title, favicon and logo of the environment's company (see src/environments). */
  protected readonly branding = inject(BrandingService);
  protected readonly orderPreview = inject(OrderPreviewService);
}
